// extracted by mini-css-extract-plugin
export default {"tenants-box":"Tenants_tenants-box__LpxS7","card":"Tenants_card__CaxKI","selectOption":"Tenants_selectOption__R2Ary"};